import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import notFoundImage from "../assets/not_found.png";

// Fade-in animation for a smooth entrance
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  padding: 60px;
  background: #002F2F;
  animation: ${fadeIn} 1s ease-out;
  text-align: center;
`;

// The title is shown only when the image fails to load
const Title = styled.h1`
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 20px;
`;

const ImageWrapper = styled.div`
  display: inline-block;
  padding: 10px;
  border: 2px solid #fff;
  border-radius: 15px;
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.5);
  margin-bottom: 30px;
`;

const Image = styled.img`
  width: 100%;
  max-width: 800px;
  border-radius: 10px;
`;

const HomeLink = styled(Link)`
  font-size: 1.2rem;
  color: #002F2F;
  background: #fff;
  text-decoration: none;
  padding: 10px 20px;
  border-radius: 5px;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: #005F5F; /* Greenish hover color */
    color: white;
  }
`;

const NotFound = () => {
  const [imgError, setImgError] = useState(false);
  const navigate = useNavigate();
useEffect(()=>{
navigate("/not_found");
},[])
  return (
    <Container>
      {imgError && <Title>404 - Page Not Found</Title>}
      {!imgError && (
        <ImageWrapper>
          <Image
            src={notFoundImage}
            alt="Not Found"
            onError={() => setImgError(true)}
          />
        </ImageWrapper>
      )}
      <HomeLink to="/">Return Home</HomeLink>
    </Container>
  );
};

export default NotFound;
